import { useEventListener } from '../useEventListener';
export function useClickAnyWhere(handler) {
    useEventListener('click', event => {
        handler(event);
    });
}
